export enum ApApplicationMode {
  Constant = 1,
  Variable = 2,
  Online = 3
}
